// extracted by mini-css-extract-plugin
export default {"menu-wrapper":"SettingMenu_menu-wrapper__PHJyc","menu-item":"SettingMenu_menu-item__s0GbN"};